export enum SupplyRequestStatusEnum {
  Draft = 0,
  Submitted = 1,
  Voided = 2,
}
